export function getCookie(cookieName: string) {
  const cookieValue = document.cookie.split('; ').find(cookie => {
    const key = cookie.split('=')[0];
    return key === cookieName;
  });
  return cookieValue ? decodeURIComponent(cookieValue.split('=')[1]) : '';
}
